/* eslint-disable no-param-reassign */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '..';

import prospectApi from '@api/prospectApi';
import type { Call } from '@lib/types/api/call';
import type { Prospect } from '@lib/types/api/prospect';

const initialState: { prospect: Prospect | null; currentStep: number } = {
  prospect: null,
  currentStep: 0,
};

const comparatorSlice = createSlice({
  initialState,
  name: 'comparator',
  reducers: {
    setDefaultData: (state, { payload }: PayloadAction<Prospect | null | undefined>) => {
      if (payload === undefined) {
        return;
      }

      if (state.prospect === null) {
        state.prospect = payload;
        return;
      }
      Object.assign(state.prospect, payload);
    },
    addCallToProspect: (state, { payload }: PayloadAction<Call>) => {
      if (state.prospect) {
        if (!state.prospect.calls) {
          state.prospect.calls = [];
        }
        state.prospect.calls.push(payload);
      }
    },
    editLastCallInProspect: (state, { payload }: PayloadAction<Call>) => {
      if (state.prospect) {
        if (!state.prospect.calls) {
          state.prospect.calls = [payload];
        } else {
          state.prospect.calls.splice(-1, 1, payload);
        }
      }
    },
    setCurrentStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(prospectApi.endpoints.patchProspect.matchFulfilled, (state, { payload }) => {
      if (state.prospect === null) {
        // Tricks because the payload is not correctly typed
        state.prospect = payload as unknown as Prospect;
        return;
      }

      Object.assign(state.prospect, payload);
    });
  },
});

export const { setDefaultData, addCallToProspect, editLastCallInProspect, setCurrentStep } = comparatorSlice.actions;

export const selectComparatorProspect = (state: RootState) => state.comparator.prospect;
export const selectCurrentStep = (state: RootState) => state.comparator.currentStep;

export default comparatorSlice;
